import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({
  children,
  requiredPermissions = [],
  requireAll = true,
  fallback = null,
}) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div>Loading...</div>; // Or a spinner component
  }

  if (!isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to. This allows us to send them along to that page after they login.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const required = Array.isArray(requiredPermissions)
    ? requiredPermissions.filter((permission) => typeof permission === 'string' && permission.trim().length > 0)
    : [];
  if (required.length > 0) {
    const userPermissions = Array.isArray(user?.permissions) ? user.permissions : [];
    const hasPermissions = requireAll
      ? required.every((permission) => userPermissions.includes(permission))
      : required.some((permission) => userPermissions.includes(permission));
    if (!hasPermissions) {
      if (fallback) return fallback;
      return (
        <div className="p-6">
          <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
            Access denied: you do not have permission to view this screen.
          </div>
        </div>
      );
    }
  }

  return children;
};

export default ProtectedRoute;
